module.exports = __webpack_public_path__ + "img/edit.6e6d0d58.svg";